var AppGoogleMap = (function () {
    let map = null;
    let infoWindow = new google.maps.InfoWindow(); //Only want one instance of the info window.
    let domMapID = null;
    // Documentation on all Map Options -- https://developers.google.com/maps/documentation/javascript/reference/3/map#MapOptions
    // Documentation on all Marker Options -- https://developers.google.com/maps/documentation/javascript/reference/3/marker#MarkerOptions

    /*
        Initialize map events
    */
    var _mapInit = () => {
        bindClickEvents();
    }

    /*
        Fetches all stores for a brand (IE Monro)
    */
    var getStoresByBrand = (domMapId, mapOptions, markerOptions) => {
        fetch(window.location.origin +
                `/wp-json/monro/v1/stores/brand?brand=${Util.getCookie('brand_id')}`)
            .then((resp) => resp.json())
            .then((stores) => {
                _mapInit(); // Initialize map events
                map = new google.maps.Map(document.getElementById(domMapId), mapOptions);
                map.addListener('tilesloaded', function(evt){
                    window.setTimeout(function() {
                        jQuery("#" + domMapId).find("img").each(function(i, eimg){
                            if(!eimg.alt || eimg.alt ===""){
                                eimg.alt = "Google Maps Image";
                            }
                        });
                    }, 1000);
                });
                addStoreMarkersToMap(stores.data, markerOptions);
            });
    }

    /*
        Fetches a single store and generates map on that stores coordinates
    */
    var getSingleStore = (storeId, domMapId, mapOptions, markerOptions) => {
        const storeInfo = JSON.parse(Util.getCookie('store_info'));

        //intentionally !=, one value is a number, the other is a string
        if((!storeInfo || !storeInfo.data || !storeInfo.data[0]) || (storeInfo && storeInfo.data && storeInfo.data[0].Id != storeId)) {
            fetch(window.location.origin +
                    `/wp-json/monro/v1/store?id=${storeId}`)
                .then((resp) => resp.json())
                .then((store) => {
                    generateStoreMap(store, domMapId, mapOptions, markerOptions);
                });
        }
        else {
            generateStoreMap(storeInfo, domMapId, mapOptions, markerOptions);
        }
    }

    /*
        Helper function for getSingleStore, to reduce the amount of duplicated code
    */
    var generateStoreMap = (store, domMapId, mapOptions, markerOptions) => {
        // If there is no store data due to an inactive or invalid store id, clear the store_location cookie and reload page to avoid empty data rendering in the location flyout
        if (store.data.length === 0) {
            Util.clearCookie('store_location');
            location.reload();
        }
        else {
            _mapInit();
            let center = {
                lat: parseFloat(store.data[0].Latitude),
                lng: parseFloat(store.data[0].Longitude)
            }
            let gmOptions = {
                ...mapOptions,
                center: center
            }
            map = new google.maps.Map(document.getElementById(domMapId), gmOptions);
            map.addListener('tilesloaded', function(evt){
                window.setTimeout(function() {
                    jQuery("#" + domMapId).find("img").each(function(i, eimg){
                        if(!eimg.alt || eimg.alt ===""){
                            eimg.alt = "Google Maps Image";
                        }
                    });
                }, 1000);
            });
            addStoreMarkersToMap(store.data, markerOptions);
            Util.setCookie('store_info', JSON.stringify(store), null);
        }
    }

    // Takes an array of storedata, displays pins on map
    var displayCollectionStoreMap = (storeData, domMapId, mapOptions, markerOptions) => {
        _mapInit();
        let center = {
            lat: parseFloat(storeData[0].Latitude),
            lng: parseFloat(storeData[0].Longitude)
        }
        let gmOptions = {
            ...mapOptions,
            center: center
        }
        map = new google.maps.Map(document.getElementById(domMapId), gmOptions);
        map.addListener('tilesloaded', function(evt){
            window.setTimeout(function() {
                jQuery("#" + domMapId).find("img").each(function(i, eimg){
                    if(!eimg.alt || eimg.alt ===""){
                        eimg.alt = "Google Maps Image";
                    }
                });
            }, 1000);
        });
        addStoreMarkersToMap(storeData, markerOptions);
    }



    /*
        Creates map markers based on storeData array
    */
    var addStoreMarkersToMap = (storeData, options) => {
        storeData.forEach((store, index) => {
            let defaultOptions = {
                map: map,
                position: {
                    lat: parseFloat(store.Latitude),
                    lng: parseFloat(store.Longitude)
                }
            }

            let markerOptions = {
                ...defaultOptions,
                ...options,
            };

            if (options.indexedPins) {
                markerOptions.label = {
                    text: `${index + 1}`,
                    color: "white"
                }
            }

            var marker = new google.maps.Marker(markerOptions);

            if (markerOptions.clickable) {
                marker.addListener('click', function () {
                    infoWindow.setContent(markerWindow(store));
                    infoWindow.open(map, marker);
                });
            }

        });
    }

    /*
        HTML for the map marker info window
    */
    var markerWindow = (store) => {
        return `
            <div class="marker-window">
                <div class="window-store">${store.City}</div>
                <div class="window-address">${store.Address}</div>
                <div class="window-phone">${store[Util.getDniColumn()]}</div>
                ${store.Id !== Util.getCookie('store_location') ? '<div class="make-my-store monro-button monro-button-red" data-brandID="'+store.BrandId+'" data-storeID="'+store.Id+'" data-makestore="true">Make my store</div>' : '<a href="/make-an-appointment"><div class="make-my-store monro-button monro-button-red">Schedule an Appointment</div> </a>'}
                <a target="_blank" href="https://www.google.com/maps/dir/Current+Location/${store.Latitude},${store.Longitude}/@${store.Latitude},${store.Longitude}"><div class="marker-get-directions monro-button monro-button-white">Get Directions</div></a>
            </div>
        `;
    }
    /*
        Set your store from "full" map view
    */
    var bindClickEvents = () => {
        jQuery(document).on('click', '#homepage-location-map .make-my-store', function () {
            Util.setCookie('store_location', jQuery(this).data('storeid'), '180');
            window.location.reload();
        });
    }

    return {
        displaySingleStoreMap: getSingleStore,
        displayCollectionStoreMap: displayCollectionStoreMap,
        displayBrandMap: getStoresByBrand
    };
})();